
import { useEffect, useState, type JSX } from "react";
import { useForm } from "react-hook-form"
import { RoleLevel, roles, type User } from "../../types/Users";
import { FloatinBooleanBootstrap, FloatingInputBootStrap, FloatingPrefixInputBootStrap } from "../Common/FloatingInputBootstrap";
import { RoleSelectorBootstrap } from "../Common/RoleSelector";
import type { ResponseError } from "../../types/CommonReponse";
import { useAddUserMutation } from "../../stores/OkOkStore";
import { Navigate, useLocation } from "react-router";
import PasswordSetter from "../Common/PasswordSetter";

import { validateNumNational } from "../../tools/validations";
import { useAuth } from "../../contexts/auth/useAuth";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";






export function  UserAddForm (): JSX.Element {
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const {translate}=useTrads();
    const [addUser,result]=useAddUserMutation();
    
    const  userParam:Partial<User>={};
    const {hasRole,userRole} = useAuth();

    const [needNumNat,setNeedNumNat]=useState(false);

    if(state?.row){
        const row=state.row as Partial<User>;
        Object.keys(state.row).forEach(element => {
            userParam[element]=row[element];
        });
    }

    const { register, handleSubmit,setError,watch, formState: { errors }  } = useForm({
        defaultValues:userParam,
        shouldUseNativeValidation: true,
        mode:'onSubmit',
    });

    const password=watch('password');
    const password_verif=watch('password_verif');
    const rangacces = watch('rangacces');


    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        setError(i, {type:'validate',message: translate(errors[i])});
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    useEffect(()=>{
        if(rangacces==roles.Beneficiaires){
            setNeedNumNat(true);
        }else{
            setNeedNumNat(false);
        }
    },[rangacces])
    
    return (
        result.isSuccess ? 
            (state?.return_url?
                <Navigate to={state.return_url}></Navigate>
            :
            <Navigate to={`/user/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate> 
            )
        :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ?  <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :

        <form className="row" onSubmit={(event) => void handleSubmit(addUser)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="identifiant"
                    label={translate('user_identifiant')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("identifiant", {
                    required: translate("user_error_identifiant_requis"),
                    minLength: 2
                    })} 
                />
            </div>

            <div className="col-12  mb-3">
                <PasswordSetter
                    name="password"
                    label={translate('user_password')}
                    errors={errors}
                    rest={{"autoComplete":"off"}}
                    registerOutput= {register("password", {
                    required: translate("register_password_required"),
                    minLength: 2,
                    validate: value => {
                        if(password_verif && value !== password_verif){
                            return translate("password_verif_mismatch");
                        }
                        return true;
                    }})} 
                    registerOutputValidation= {register("password_verif", {
                    required: translate("register_password_verif_required"),
                    minLength: 2,
                    validate: value => value === password || translate("password_verif_mismatch")
                    })} 
                />
            </div>


            <div className="col-12  mb-3">
                <FloatingPrefixInputBootStrap
                    name="email"
                    label={translate('profil_email')}
                    type="email"
                    prefix="@"
                    errors={errors}
                    registerOutput= {register("email", {
                    required: translate("email_required"),
                    minLength: 2
                    })} 
                />
            </div>
            <div className="col-12  mb-3">

                <FloatingInputBootStrap
                    name="nom"
                    label={translate('profil_nom')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("nom", {
                    required: translate("user_error_nom_requis"),
                    minLength: 2
                    })} 
                />
            </div>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="prenom"
                    label={translate('profil_prenom')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("prenom", {
                    required: translate("user_error_prenom_requis"),
                    minLength: 2
                    })} 
                />
            </div>


            <div className="col-12  mb-3">
                <RoleSelectorBootstrap
                    label={translate('user_role')}
                    name="rangacces"
                    registerOutput={register("rangacces", {
                        required: translate("user_error_role_requis"),
                    })}
                    maxlevel={RoleLevel[userRole??roles.Visitors]}
                    errors={errors}
                />
            </div>            
            {needNumNat?
                <div className="col-12  mb-3">

                    <FloatingInputBootStrap 
                        name='numero_national' 
                        label={translate('profil_num_national')}
                        type='text' 
                        registerOutput={register("numero_national", {
                            required: translate("user_error_num_national_requis"),
                            validate:(value) => validateNumNational(value??'',translate),
                        })}
                        errors={errors}
                    />


                </div>
            :null}

            {(hasRole(roles.Administrators))?
            
                <div className="col-12  mb-3">
                <FloatinBooleanBootstrap
                    name="valide"
                    label={translate('user_valide')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("valide")} 
                />
            </div>
            :null}

            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    );
};

export default UserAddForm;